import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';

export const ACCOUNT_GET_UNSEEN_MESSAGES = graphql(`
  query AccountGetUnseenMessages {
    unseenMessages {
      id
      fromAccountId
    }
  }
`);

export const useUnseenMessages = () => {
  const { data, error, loading } = useQuery(ACCOUNT_GET_UNSEEN_MESSAGES, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
    ssr: false,
    pollInterval: 20000,
  });

  return {
    unseenMessages: data?.unseenMessages ?? [],
    unseenMessagesAmount: (data?.unseenMessages ?? []).length,
    unseenMessagesError: error,
    unseenMessagesLoading: loading,
  };
};
